/* generated by scripts/generate-phosphor-registry.mjs — do not edit */
import type { Icon } from "@phosphor-icons/react";

import type { IconName } from "./icon-names";
import { AnchorIcon } from "@phosphor-icons/react/dist/csr/Anchor";
import { ArmchairIcon } from "@phosphor-icons/react/dist/csr/Armchair";
import { ArrowClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowClockwise";
import { ArrowCounterClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowCounterClockwise";
import { ArrowDownIcon } from "@phosphor-icons/react/dist/csr/ArrowDown";
import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { ArrowLineDownIcon } from "@phosphor-icons/react/dist/csr/ArrowLineDown";
import { ArrowLineUpIcon } from "@phosphor-icons/react/dist/csr/ArrowLineUp";
import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { ArrowsClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowsClockwise";
import { ArrowsDownUpIcon } from "@phosphor-icons/react/dist/csr/ArrowsDownUp";
import { ArrowsInIcon } from "@phosphor-icons/react/dist/csr/ArrowsIn";
import { ArrowsInLineVerticalIcon } from "@phosphor-icons/react/dist/csr/ArrowsInLineVertical";
import { ArrowsOutIcon } from "@phosphor-icons/react/dist/csr/ArrowsOut";
import { ArrowsOutLineVerticalIcon } from "@phosphor-icons/react/dist/csr/ArrowsOutLineVertical";
import { ArrowSquareOutIcon } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { ArrowUpIcon } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { ArrowUpRightIcon } from "@phosphor-icons/react/dist/csr/ArrowUpRight";
import { ArticleIcon } from "@phosphor-icons/react/dist/csr/Article";
import { AtIcon } from "@phosphor-icons/react/dist/csr/At";
import { BellIcon } from "@phosphor-icons/react/dist/csr/Bell";
import { BellSlashIcon } from "@phosphor-icons/react/dist/csr/BellSlash";
import { BooksIcon } from "@phosphor-icons/react/dist/csr/Books";
import { BracketsCurlyIcon } from "@phosphor-icons/react/dist/csr/BracketsCurly";
import { BuildingsIcon } from "@phosphor-icons/react/dist/csr/Buildings";
import { CalculatorIcon } from "@phosphor-icons/react/dist/csr/Calculator";
import { CalendarBlankIcon } from "@phosphor-icons/react/dist/csr/CalendarBlank";
import { CarIcon } from "@phosphor-icons/react/dist/csr/Car";
import { CaretDoubleLeftIcon } from "@phosphor-icons/react/dist/csr/CaretDoubleLeft";
import { CaretDoubleRightIcon } from "@phosphor-icons/react/dist/csr/CaretDoubleRight";
import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { CaretLeftIcon } from "@phosphor-icons/react/dist/csr/CaretLeft";
import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { CaretUpIcon } from "@phosphor-icons/react/dist/csr/CaretUp";
import { ChartBarIcon } from "@phosphor-icons/react/dist/csr/ChartBar";
import { ChartLineIcon } from "@phosphor-icons/react/dist/csr/ChartLine";
import { ChartPieIcon } from "@phosphor-icons/react/dist/csr/ChartPie";
import { ChartScatterIcon } from "@phosphor-icons/react/dist/csr/ChartScatter";
import { ChatCircleIcon } from "@phosphor-icons/react/dist/csr/ChatCircle";
import { ChatCircleTextIcon } from "@phosphor-icons/react/dist/csr/ChatCircleText";
import { CheckIcon } from "@phosphor-icons/react/dist/csr/Check";
import { CheckCircleIcon } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { ChecksIcon } from "@phosphor-icons/react/dist/csr/Checks";
import { CheckSquareIcon } from "@phosphor-icons/react/dist/csr/CheckSquare";
import { CircleIcon } from "@phosphor-icons/react/dist/csr/Circle";
import { CircleDashedIcon } from "@phosphor-icons/react/dist/csr/CircleDashed";
import { CircleHalfIcon } from "@phosphor-icons/react/dist/csr/CircleHalf";
import { CircleNotchIcon } from "@phosphor-icons/react/dist/csr/CircleNotch";
import { ClockIcon } from "@phosphor-icons/react/dist/csr/Clock";
import { CodeIcon } from "@phosphor-icons/react/dist/csr/Code";
import { ColumnsIcon } from "@phosphor-icons/react/dist/csr/Columns";
import { CookingPotIcon } from "@phosphor-icons/react/dist/csr/CookingPot";
import { CopyIcon } from "@phosphor-icons/react/dist/csr/Copy";
import { CopySimpleIcon } from "@phosphor-icons/react/dist/csr/CopySimple";
import { CpuIcon } from "@phosphor-icons/react/dist/csr/Cpu";
import { CreditCardIcon } from "@phosphor-icons/react/dist/csr/CreditCard";
import { CropIcon } from "@phosphor-icons/react/dist/csr/Crop";
import { CubeIcon } from "@phosphor-icons/react/dist/csr/Cube";
import { CursorClickIcon } from "@phosphor-icons/react/dist/csr/CursorClick";
import { DatabaseIcon } from "@phosphor-icons/react/dist/csr/Database";
import { DeviceMobileIcon } from "@phosphor-icons/react/dist/csr/DeviceMobile";
import { DotsSixVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsSixVertical";
import { DotsThreeIcon } from "@phosphor-icons/react/dist/csr/DotsThree";
import { DotsThreeVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { DownloadSimpleIcon } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { DropIcon } from "@phosphor-icons/react/dist/csr/Drop";
import { EnvelopeIcon } from "@phosphor-icons/react/dist/csr/Envelope";
import { EyeIcon } from "@phosphor-icons/react/dist/csr/Eye";
import { EyeSlashIcon } from "@phosphor-icons/react/dist/csr/EyeSlash";
import { FactoryIcon } from "@phosphor-icons/react/dist/csr/Factory";
import { FadersIcon } from "@phosphor-icons/react/dist/csr/Faders";
import { FileTextIcon } from "@phosphor-icons/react/dist/csr/FileText";
import { FlagIcon } from "@phosphor-icons/react/dist/csr/Flag";
import { FlaskIcon } from "@phosphor-icons/react/dist/csr/Flask";
import { FlipHorizontalIcon } from "@phosphor-icons/react/dist/csr/FlipHorizontal";
import { FloppyDiskIcon } from "@phosphor-icons/react/dist/csr/FloppyDisk";
import { ForkKnifeIcon } from "@phosphor-icons/react/dist/csr/ForkKnife";
import { FunctionIcon } from "@phosphor-icons/react/dist/csr/Function";
import { FunnelIcon } from "@phosphor-icons/react/dist/csr/Funnel";
import { FunnelSimpleIcon } from "@phosphor-icons/react/dist/csr/FunnelSimple";
import { GearIcon } from "@phosphor-icons/react/dist/csr/Gear";
import { GitDiffIcon } from "@phosphor-icons/react/dist/csr/GitDiff";
import { GitMergeIcon } from "@phosphor-icons/react/dist/csr/GitMerge";
import { GlobeIcon } from "@phosphor-icons/react/dist/csr/Globe";
import { GridFourIcon } from "@phosphor-icons/react/dist/csr/GridFour";
import { HouseIcon } from "@phosphor-icons/react/dist/csr/House";
import { ImageIcon } from "@phosphor-icons/react/dist/csr/Image";
import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { LightningIcon } from "@phosphor-icons/react/dist/csr/Lightning";
import { LinkIcon } from "@phosphor-icons/react/dist/csr/Link";
import { ListIcon } from "@phosphor-icons/react/dist/csr/List";
import { ListBulletsIcon } from "@phosphor-icons/react/dist/csr/ListBullets";
import { LockIcon } from "@phosphor-icons/react/dist/csr/Lock";
import { MagicWandIcon } from "@phosphor-icons/react/dist/csr/MagicWand";
import { MagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { MapPinIcon } from "@phosphor-icons/react/dist/csr/MapPin";
import { MemoryIcon } from "@phosphor-icons/react/dist/csr/Memory";
import { MinusIcon } from "@phosphor-icons/react/dist/csr/Minus";
import { MoonIcon } from "@phosphor-icons/react/dist/csr/Moon";
import { NoteIcon } from "@phosphor-icons/react/dist/csr/Note";
import { NotePencilIcon } from "@phosphor-icons/react/dist/csr/NotePencil";
import { PackageIcon } from "@phosphor-icons/react/dist/csr/Package";
import { PaintBrushIcon } from "@phosphor-icons/react/dist/csr/PaintBrush";
import { PaintBucketIcon } from "@phosphor-icons/react/dist/csr/PaintBucket";
import { PaletteIcon } from "@phosphor-icons/react/dist/csr/Palette";
import { PaperPlaneTiltIcon } from "@phosphor-icons/react/dist/csr/PaperPlaneTilt";
import { PauseIcon } from "@phosphor-icons/react/dist/csr/Pause";
import { PencilSimpleIcon } from "@phosphor-icons/react/dist/csr/PencilSimple";
import { PersonArmsSpreadIcon } from "@phosphor-icons/react/dist/csr/PersonArmsSpread";
import { PhoneIcon } from "@phosphor-icons/react/dist/csr/Phone";
import { PlantIcon } from "@phosphor-icons/react/dist/csr/Plant";
import { PlayIcon } from "@phosphor-icons/react/dist/csr/Play";
import { PlayCircleIcon } from "@phosphor-icons/react/dist/csr/PlayCircle";
import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { PowerIcon } from "@phosphor-icons/react/dist/csr/Power";
import { PrinterIcon } from "@phosphor-icons/react/dist/csr/Printer";
import { PushPinIcon } from "@phosphor-icons/react/dist/csr/PushPin";
import { PushPinSlashIcon } from "@phosphor-icons/react/dist/csr/PushPinSlash";
import { PuzzlePieceIcon } from "@phosphor-icons/react/dist/csr/PuzzlePiece";
import { ReceiptIcon } from "@phosphor-icons/react/dist/csr/Receipt";
import { RepeatIcon } from "@phosphor-icons/react/dist/csr/Repeat";
import { RobotIcon } from "@phosphor-icons/react/dist/csr/Robot";
import { RowsIcon } from "@phosphor-icons/react/dist/csr/Rows";
import { ShapesIcon } from "@phosphor-icons/react/dist/csr/Shapes";
import { ShareNetworkIcon } from "@phosphor-icons/react/dist/csr/ShareNetwork";
import { ShieldIcon } from "@phosphor-icons/react/dist/csr/Shield";
import { ShieldCheckIcon } from "@phosphor-icons/react/dist/csr/ShieldCheck";
import { SidebarIcon } from "@phosphor-icons/react/dist/csr/Sidebar";
import { SidebarSimpleIcon } from "@phosphor-icons/react/dist/csr/SidebarSimple";
import { SignOutIcon } from "@phosphor-icons/react/dist/csr/SignOut";
import { SmileyIcon } from "@phosphor-icons/react/dist/csr/Smiley";
import { SparkleIcon } from "@phosphor-icons/react/dist/csr/Sparkle";
import { SquareIcon } from "@phosphor-icons/react/dist/csr/Square";
import { SquaresFourIcon } from "@phosphor-icons/react/dist/csr/SquaresFour";
import { StackIcon } from "@phosphor-icons/react/dist/csr/Stack";
import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";
import { SunIcon } from "@phosphor-icons/react/dist/csr/Sun";
import { TableIcon } from "@phosphor-icons/react/dist/csr/Table";
import { TagIcon } from "@phosphor-icons/react/dist/csr/Tag";
import { TrashIcon } from "@phosphor-icons/react/dist/csr/Trash";
import { TreeStructureIcon } from "@phosphor-icons/react/dist/csr/TreeStructure";
import { TrendUpIcon } from "@phosphor-icons/react/dist/csr/TrendUp";
import { TruckIcon } from "@phosphor-icons/react/dist/csr/Truck";
import { TShirtIcon } from "@phosphor-icons/react/dist/csr/TShirt";
import { UploadSimpleIcon } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { UsersIcon } from "@phosphor-icons/react/dist/csr/Users";
import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { WarningCircleIcon } from "@phosphor-icons/react/dist/csr/WarningCircle";
import { WrenchIcon } from "@phosphor-icons/react/dist/csr/Wrench";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { XCircleIcon } from "@phosphor-icons/react/dist/csr/XCircle";

export const PHOSPHOR_BY_MATERIAL = {
  accessibility_new: PersonArmsSpreadIcon,
  account_tree: TreeStructureIcon,
  add: PlusIcon,
  add_comment: ChatCircleTextIcon,
  ads_click: CursorClickIcon,
  agriculture: PlantIcon,
  alternate_email: AtIcon,
  anchor: AnchorIcon,
  apartment: BuildingsIcon,
  arrow_back: ArrowLeftIcon,
  arrow_downward: ArrowDownIcon,
  arrow_forward: ArrowRightIcon,
  arrow_upward: ArrowUpIcon,
  article: ArticleIcon,
  auto_awesome: SparkleIcon,
  auto_fix_high: MagicWandIcon,
  bar_chart: ChartBarIcon,
  bolt: LightningIcon,
  brush: PaintBrushIcon,
  build: WrenchIcon,
  calculate: CalculatorIcon,
  calendar_today: CalendarBlankIcon,
  call: PhoneIcon,
  cancel: XCircleIcon,
  category: ShapesIcon,
  chair: ArmchairIcon,
  chat_bubble: ChatCircleIcon,
  check: CheckIcon,
  check_box: CheckSquareIcon,
  check_circle: CheckCircleIcon,
  checkroom: TShirtIcon,
  chevron_left: CaretLeftIcon,
  chevron_right: CaretRightIcon,
  circle: CircleIcon,
  close: XIcon,
  close_fullscreen: ArrowsInIcon,
  code: CodeIcon,
  content_copy: CopyIcon,
  cooking: CookingPotIcon,
  credit_card: CreditCardIcon,
  crop: CropIcon,
  crop_square: SquareIcon,
  dark_mode: MoonIcon,
  dashboard: SquaresFourIcon,
  data_object: BracketsCurlyIcon,
  database: DatabaseIcon,
  delete: TrashIcon,
  description: FileTextIcon,
  deployed_code: CubeIcon,
  developer_board: CpuIcon,
  difference: GitDiffIcon,
  directions_car: CarIcon,
  done_all: ChecksIcon,
  download: DownloadSimpleIcon,
  drag_indicator: DotsSixVerticalIcon,
  edit: PencilSimpleIcon,
  edit_note: NotePencilIcon,
  error: WarningCircleIcon,
  expand_less: CaretUpIcon,
  expand_more: CaretDownIcon,
  extension: PuzzlePieceIcon,
  factory: FactoryIcon,
  file_copy: CopySimpleIcon,
  filter_alt: FunnelIcon,
  filter_list: FunnelSimpleIcon,
  flag: FlagIcon,
  flip: FlipHorizontalIcon,
  format_paint: PaintBucketIcon,
  function: FunctionIcon,
  grid_view: SquaresFourIcon,
  group: UsersIcon,
  home: HouseIcon,
  image: ImageIcon,
  info: InfoIcon,
  inventory_2: PackageIcon,
  keep: PushPinIcon,
  keep_off: PushPinSlashIcon,
  keyboard_double_arrow_left: CaretDoubleLeftIcon,
  keyboard_double_arrow_right: CaretDoubleRightIcon,
  label: TagIcon,
  layers: StackIcon,
  left_panel_close: SidebarSimpleIcon,
  light_mode: SunIcon,
  link: LinkIcon,
  list: ListIcon,
  local_library: BooksIcon,
  local_shipping: TruckIcon,
  location_on: MapPinIcon,
  lock: LockIcon,
  logout: SignOutIcon,
  mail: EnvelopeIcon,
  memory: MemoryIcon,
  menu: ListIcon,
  merge: GitMergeIcon,
  more_horiz: DotsThreeIcon,
  more_vert: DotsThreeVerticalIcon,
  north_east: ArrowUpRightIcon,
  notifications: BellIcon,
  notifications_off: BellSlashIcon,
  open_in_full: ArrowsOutIcon,
  open_in_new: ArrowSquareOutIcon,
  package_2: PackageIcon,
  palette: PaletteIcon,
  pause: PauseIcon,
  pending: CircleDashedIcon,
  pie_chart: ChartPieIcon,
  play_arrow: PlayIcon,
  power: PowerIcon,
  print: PrinterIcon,
  progress_activity: CircleNotchIcon,
  receipt: ReceiptIcon,
  redo: ArrowClockwiseIcon,
  refresh: ArrowsClockwiseIcon,
  remove: MinusIcon,
  repeat: RepeatIcon,
  restaurant: ForkKnifeIcon,
  right_panel_open: SidebarIcon,
  save: FloppyDiskIcon,
  scatter_plot: ChartScatterIcon,
  schedule: ClockIcon,
  science: FlaskIcon,
  search: MagnifyingGlassIcon,
  sell: TagIcon,
  send: PaperPlaneTiltIcon,
  sentiment_satisfied: SmileyIcon,
  settings: GearIcon,
  share: ShareNetworkIcon,
  shield: ShieldIcon,
  show_chart: ChartLineIcon,
  smart_toy: RobotIcon,
  smartphone: DeviceMobileIcon,
  star: StarIcon,
  sticky_note_2: NoteIcon,
  swap_vert: ArrowsDownUpIcon,
  table: TableIcon,
  table_rows: RowsIcon,
  tonality: CircleHalfIcon,
  trending_up: TrendUpIcon,
  tune: FadersIcon,
  undo: ArrowCounterClockwiseIcon,
  unfold_less: ArrowsInLineVerticalIcon,
  unfold_more: ArrowsOutLineVerticalIcon,
  upload: UploadSimpleIcon,
  verified_user: ShieldCheckIcon,
  vertical_align_bottom: ArrowLineDownIcon,
  vertical_align_top: ArrowLineUpIcon,
  view_column: ColumnsIcon,
  view_list: ListBulletsIcon,
  view_week: ColumnsIcon,
  visibility: EyeIcon,
  visibility_off: EyeSlashIcon,
  warning: WarningIcon,
  water_drop: DropIcon,
  widgets: GridFourIcon,
} as const satisfies Record<IconName, Icon>;

export const PHOSPHOR_BY_ESCAPE = {
  email: EnvelopeIcon,
  play_circle: PlayCircleIcon,
  web: GlobeIcon,
} as const satisfies Record<string, Icon>;
